import classnames from 'classnames';
import React from 'react';
import { ILayerProps } from '@/version-types';
import { useScale } from '../../stage/hooks';

export const BaseOperateView = React.forwardRef<
    HTMLDivElement,
    { layer: ILayerProps; children?: React.ReactNode; style?: React.CSSProperties }
>(({ layer, children, style = {} }, ref) => {
    const scale = useScale();
    const { width, height, left, top, rotate } = layer;

    return (
        <div
            ref={ref}
            className={classnames('base-operate')}
            style={{
                width: width * scale,
                height: height * scale,
                transform: `translate(${left * scale}px, ${top * scale}px) rotate(${rotate}deg)`,
                ...style,
            }}
        >
            {children}
        </div>
    );
});
